import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { ACURA_SITE_NAME, HONDA_SITE_NAME, MARINE_SITE_NAME, PE_SITE_NAME, PSP_SITE_NAME } from '../../utils/constants';
import { variant1, variant2, variant3, variant4, variant5 } from './constants';
import SpecialOffersList from './SpecialOffersList';
import { SpecialOffersContextProvider } from './SpecialOffersContext';
import { useAppName } from '../../utils/sitecoreContext';
const SpecialOffers = ({ fields }) => {
    const appName = useAppName();
    let variant = variant1;
    switch (appName) {
        case HONDA_SITE_NAME:
            variant = variant1;
            break;
        case ACURA_SITE_NAME:
            variant = variant2;
            break;
        case PSP_SITE_NAME:
            variant = variant3;
            break;
        case PE_SITE_NAME:
            variant = variant4;
            break;
        case MARINE_SITE_NAME:
            variant = variant5;
            break;
        default:
            break;
    }
    return (_jsx(SpecialOffersContextProvider, { variant: variant, children: _jsx(SpecialOffersList, { fields: fields }) }));
};
export default SpecialOffers;
